import { AccountType } from "component-library";

export enum JobsPageTab {
  MyFilter = "matchingMyFilter",
  AllPaid = "allPaid",
  All = "allOpportunities",
  ClientAlerts = "clientAlerts",
  SelfTapeRequests = "selfTapeRequests",
  MySuggestions = "mySuggestions",
}

export const userTypeToHiddenTabListMap = {
  [AccountType.Performer]: [JobsPageTab.ClientAlerts],
  [AccountType.Agent]: [JobsPageTab.AllPaid],
} as Record<AccountType, JobsPageTab[]>;

export enum JobsPageBreadcrumb {
  MyAccount = "MyAccount",
}

export const SEARCH_MAX_LENGTH = 100;
